import { Box, Skeleton, useTheme } from "@mui/material";
import type { FC } from "react";
import { useChatAttachmentImage } from "web_myplann/Api/Chat/useChatAttachmentImage";

type Props = {
	attachmentId: number;
	fileName: string;
};

const MAX_HEIGHT = 240;

export const ChatAttachmentImage: FC<Props> = ({ attachmentId, fileName }) => {
	const theme = useTheme();
	const { url, isLoading } = useChatAttachmentImage(attachmentId, true);

	if (isLoading || !url) {
		return (
			<Skeleton
				variant="rounded"
				width={180}
				height={180}
				sx={{ borderRadius: theme.radii.xl }}
			/>
		);
	}

	return (
		<Box
			component="img"
			src={url}
			alt={fileName}
			display="block"
			maxWidth="100%"
			maxHeight={MAX_HEIGHT}
			borderRadius={theme.radii.xl}
			sx={{ objectFit: "cover" }}
		/>
	);
};
